<template>
  <picker-field
    :label="label"
    :value="value"
    :is-focus="isFocus"
    title="选择BOM"
    ref="picker"
    @open="onSearch"
  >
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="bo_code,bo_mothername,bo_mothercode"
        placeholder="输入编号、名称查找"
        ref="searchBar"
        :auto-search="true"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>{{ item.bo_code }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.bo_mothername }}</p>
        </div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList,
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "选择BOM",
    },
    value: String,
    listUrl: {
      type: String,
      default: "/api/make/bom/list",
    },
    extraParams: Object
  },
  data() {
    return {
      isFocus: false,
      allowEmptySearch: false,
      defaultCondition: [{
        field: "bo_statuscode",
        operation: "=",
        value: "AUDITED"
      }]
    }
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.bo_code);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  },
};
</script>